import Microgame from '../engine/Microgame.js';

export default class PumpGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Pompe !`, en: `Pump!`, es: `¡Bombea!` },
            controls: { fr: `Glisse ton doigt de bas en haut comme une seringue (plusieurs fois)`, en: `Swipe up and down like a syringe (multiple times)`, es: `Desliza arriba y abajo como una jeringa (varias veces)` },
            objective: { fr: `Gonfle complètement le ballon`, en: `Inflate the balloon completely`, es: `Infla el globo por completo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M8 2h8"/><path d="M12 2v6"/><rect x="8" y="14" width="8" height="8" rx="1"/><path d="M8 10h8v4H8z"/></svg>`,
            actions: [
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 700 },
            ],
            loopDuration: 2600
        };
    }
    constructor(engine) {
        super(engine);
        this.size = 50; // Initial radius
        this.maxSize = 150; // Visual max
        this.explodeLimit = 0; // Randomly set in setup
        this.targetSize = 120; // Minimum size to win
        this.balloon = null;

        // Progression: 3 secondes à x1, 1.3 seconde à x4
        // Base = 3000ms. En x4 (adjusted 2.307), temps restant = 1.3s.
        // Calcul amortissement: 3000 / 1300 = 2.307 => 1 + (4-1)*factor = 2.307 => 3*factor = 1.307 => factor = 0.436
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeed = 1 + (speedMult - 1) * 0.436;
        this.duration = 3000 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "PUMP!";

        // Random explosion limit between 130 and 160
        this.explodeLimit = this.isPlayback ? 200 : (130 + Math.random() * 30);

        // Balloon
        this.balloon = document.createElement('div');
        this.balloon.style.position = 'absolute';
        this.balloon.style.top = '50%';
        this.balloon.style.left = '50%';
        this.balloon.style.transform = 'translate(-50%, -50%)';
        this.balloon.style.width = `${this.size * 2}px`;
        this.balloon.style.height = `${this.size * 2}px`;
        this.balloon.style.borderRadius = '50%';
        this.balloon.style.background = `radial-gradient(circle at 30% 30%, ${this.primaryColor}, #000)`; // Simple gradient
        this.balloon.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.balloon.style.transition = 'width 0.1s, height 0.1s';
        this.container.appendChild(this.balloon);

        // Pump Button (Invisible, full screen tap)
        this.onTap = this.onTap.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onTap);
    }

    onTap() {
        if (!this.active) return;

        this.size += 10;
        this.updateBalloon();

        if (this.size > this.explodeLimit) {
            this.pop();
        } else if (this.size >= this.targetSize) {
            // Visual feedback for "Good enough"
            this.balloon.style.boxShadow = `0 0 40px ${this.secondaryColor}`; // Secondary glow for validation
        }
    }

    updateBalloon() {
        this.balloon.style.width = `${this.size * 2}px`;
        this.balloon.style.height = `${this.size * 2}px`;
    }

    pop() {
        this.balloon.style.background = 'transparent';
        this.balloon.style.boxShadow = 'none';
        this.balloon.innerHTML = '💥';
        this.balloon.style.fontSize = '100px';
        this.balloon.style.display = 'flex';
        this.balloon.style.alignItems = 'center';
        this.balloon.style.justifyContent = 'center';
        this.lose();
    }

    update(dt) {
        // If time runs out and we are big enough, we win
        if (this.engine.timer <= 0) {
            // Engine handles timeout as loss by default, so we need to intercept or just win before timeout?
            // Actually, let's make it so if you reach the target size, you win immediately?
            // No, the user said "say when it's good". Maybe a "STOP" button appears?
            // Or just: if you survive until timeout AND are big enough, you win.

            // But engine fails on timeout.
            // Let's trigger win slightly before timeout if size is good.
        }

        // Better mechanic: You have to pump it up. Once it's big enough, it glows green.
        // You have to STOP pumping and wait for time to run out? Or just stop?
        // Let's say: If you are in the range (target < size < explode) when time runs out, you win.
        // To do this, we need to prevent the default timeout fail.

        if (this.engine.timer <= 100) {
            if (this.size >= this.targetSize && this.size <= this.explodeLimit) {
                this.win();
            } else {
                // Too small
                this.lose();
            }
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onTap);
    }
}
